import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingImages(props) {

  const [mainImage, setMainImage] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);

  const handleMainImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMainImage(URL.createObjectURL(file));
    }
  };

  const handleGalleryImages = (e) => {
    const files = Array.from(e.target.files);
    const imageUrls = files.map(file => URL.createObjectURL(file));
    setGalleryImages([...galleryImages, ...imageUrls]);
  };

  const removeImage = (index) => {
    const updatedImages = galleryImages.filter((_, i) => i !== index);
    setGalleryImages(updatedImages);
  };

  return (

    <Container>

      <Row>

        {/* Title */}

        <Col md={12} className="mt-4 mb-3">
          <h4>Step 5 : Product Images</h4>
        </Col>


        {/* Upload Card */}

        <Col md={12}>

          <Card className="p-4">

            {/* Main Image */}

            <Row className="mb-4">

              <Col md={4}>
                <b>Main Image</b>
              </Col>

              <Col md={8}>

                <Input
                  type="file"
                  onChange={handleMainImage}
                />

                {mainImage && (

                  <div className="mt-3">

                    <img
                      src={mainImage}
                      alt="Main"
                      style={{
                        width: "150px",
                        borderRadius: "5px"
                      }}
                    />

                  </div>

                )}

              </Col>

            </Row>


            {/* Gallery Images */}

            <Row className="mb-3">

              <Col md={4}>
                <b>Gallery Images</b>
              </Col>

              <Col md={8}>

                <Input
                  type="file"
                  multiple
                  onChange={handleGalleryImages}
                />

              </Col>

            </Row>


            {/* Preview Images */}

            <Row>

              {galleryImages.map((img, index) => (

                <Col md={3} className="mt-3" key={index}>

                  <Card className="p-2 text-center">

                    <img
                      src={img}
                      alt="gallery"
                      style={{
                        width: "100%",
                        height: "100px",
                        objectFit: "cover"
                      }}
                    />

                    <button
                      className="btn btn-danger btn-sm mt-2"
                      onClick={() => removeImage(index)}
                    >
                      Remove
                    </button>

                  </Card>

                </Col>

              ))}

            </Row>

          </Card>

        </Col>


        {/* Navigation */}

        <Col md={12} className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <button
            className="btn btn-primary"
            onClick={props.nextStep}
          >
            Next →
          </button>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingImages;